
























import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
// eslint-disable-next-line no-unused-vars
import { Row } from '@/main/utils/table';

import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME, VOZIDLO_MERGE } from '../constants';
import { apiProvider } from '../api';

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		spz: { type: String },
		karoserieNr: { type: String },
		textLabelKey: { type: String, default: 'KAROSERIE_NR' },
		filter: { type: Object, default: () => {} },
		editPermission: { type: Boolean, default: true },
		showEditButton: { type: Boolean, default: false },
		karoserieNrAutocomplete: { type: Boolean, default: false },
	},
	data() {
		return {
			apiProvider,
			storeObject: NAME,
			valueFieldName: 'VOZIDLO_ID',
			karoserieNrSearchValue: null as string | null,
			emptyObject: {
				value: null,
				text: null,
				koncernPrp: null,
				spz: null as string | null,
				typkod: null,
				xTypkod: null,
				karoserieNr: null as string | null,
				isNonGenuine: null as boolean | null,
				nonGenuineRemark: null as string | null,
				isTotalLoss: null as boolean | null,
				totalLossRemark: null as string | null,
			},
		};
	},
	computed: {
		showMergeBtn() : boolean {
			return (this.filter && (this.filter.Ozakazka && !this.filter.VozidloId) && this.filter.VozidloKonId) && !this.showCreateBtn;
		},
		showSelectBtn() : boolean {
			return !(this.filter && this.filter.Ozakazka && !this.filter.VozidloId) || !this.filter.VozidloKonId;
		},
		showEditBtn() : boolean {
			return this.filter && this.showEditButton && !!this.filter.VozidloId;
		},
		showCreateBtn() : boolean {
			return this.filter && this.filter.Create; // TODO: bude potreba jeste zkontrolovat pravo na vytvoreni vozidla
		},
		showClearButton() : boolean {
			return !(this.filter && this.filter.Ozakazka);
		},
		spzSearchFilter() : object {
			return { Spz: this.spz, WorkshopId: this.loggedUser.PracovnikProvSelect };
		},
		karoserieNrSearchFilter() : object {
			return { KaroserieNr: this.karoserieNr, WorkshopId: this.loggedUser.PracovnikProvSelect };
		},
		textSpanCmp(): number {
			return this.isSpzDefined ? 14 : 24;
		},
		isSpzDefined(): boolean {
			return this.spz !== undefined;
		},
		spzValueCmp: {
			get(): string {
				return this.searchValue || String(this.spz);
			},
			set(val: string) {
				this.searchValue = val;
			},
		},
		karoserieNrValueCmp: {
			get(): string {
				return this.karoserieNrSearchValue || String(this.karoserieNr);
			},
			set(val: string) {
				this.karoserieNrSearchValue = val;
			},
		},
	},
	watch: {
		spz(val) {
			this.searchValue = val;
		},
		karoserieNr(val) {
			this.karoserieNrSearchValue = val;
		},
	},
	methods: {
		clearClick() {
			this.searchValue = null;
			this.karoserieNrSearchValue = null;
			this.clear();
		},
		dbToBaseMapper(data : Record<string, any>) {
			return {
				value: data.VOZIDLO_ID,
				text: `${data.X_TYPKOD} (${data.SPZ})`,
				koncernPrp: data.KONCERN_PRP,
				spz: data.SPZ,
				xTypkod: data.X_TYPKOD,
				typkod: data.TYPKOD,
				karoserieNr: data.KAROSERIE_NR,
				isNonGenuine: data.IS_NONGENUINE,
				nonGenuineRemark: data.NON_GENUINE_REMARK,
				isTotalLoss: data.IS_TOTAL_LOSS,
				totalLossRemark: data.TOTAL_LOSS_REMARK,
			};
		},
		async openEdit() {
			const pageParams = { id: this.filter.VozidloId };
			await openEdit(NAME, this.editPermission ? PageMode.EDIT : PageMode.VIEW, pageParams);
		},
		async openCreate() {
			await openEdit(NAME, PageMode.CREATE, { filter: { fromSelectCreate: true } });
		},
		async openMerge() {
			// TP1/TODO: s iID to nejak nefunguje zjistit proc
			await openEdit(VOZIDLO_MERGE, PageMode.EDIT, { id: this.filter.VozidloId, kontaktId: this.filter.VozidloKonId });
		},
		additionalInfo({ cells }: Row, cellNames: Record<string, number>): string {
			return cells[cellNames.KAROSERIE_NR];
		},
	},
});
